<script setup lang="ts">
import ScoutsLogo from "@/components/Common/ScoutsLogo.vue";
import GreetingsBlockContentHolder from "@/components/MainPage/MobileVersion/GreetingsBlock/ContentHolder.vue";
import MobileRegisterButton from "@/components/MainPage/MobileVersion/RegisterButton.vue";
import PreorderInfoBlockContentHolder from "@/components/MainPage/MobileVersion/PreorderInfoBlock/ContentHolder.vue";
import TestDescriptionBlockContentHolder
    from "@/components/MainPage/MobileVersion/TestDescriptionBlock/ContentHolder.vue";
import ReferralProgramBlockContentHolder
    from "@/components/MainPage/MobileVersion/ReferralProgramBlock/ContentHolder.vue";
</script>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'MainPageMobileVersion',
})
</script>

<template>
    <div class="main">
        <div class="wrapper">
            <ScoutsLogo/>

            <GreetingsBlockContentHolder/>

            <MobileRegisterButton/>

            <PreorderInfoBlockContentHolder/>
            <TestDescriptionBlockContentHolder/>

            <MobileRegisterButton/>

            <ReferralProgramBlockContentHolder/>
        </div>
    </div>
</template>

<style scoped lang="scss">
.main {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    padding: 30px 0 50px 0;
    overflow: hidden;
    overflow-y: scroll;

    display: block;
}

.wrapper {
    position: relative;
    z-index: 900;
    width: 100%;
    padding: 0 20px 0 20px;

    font-size: 14px;

    display: flex;
    flex-direction: column;
    gap: 40px;
    justify-content: flex-start;
    align-items: center;
}
</style>
